export const preTaxAnnualIncomeValidations = {
  min: 1,
  max: 9000000,
};

export const monthlyDebtValidations = {
  min: 0,
  stepSize: 50,
};

export const downPaymentValidations = {
  min: 0,
  max: 9000000,
};

export const interestRateValidations = {
  min: 0,
  max: 0.3,
};

export const householdIncomeValidations = {
  max: 10000000,
  min: 1,
  stepSize: 1000,
};
